import { PaginationValues } from "../types/General/PaginationValues";
import { Organization } from "../types/Organization/Organization";
import api from "../utils/api";
import { ORGANIZATION_URL } from "../utils/endpoints";

export async function getOrganization(
  id?: string,
  filterValues?: any,
  paginationValues?: PaginationValues,
) {
  try {
    const response = await api.get(
      id ? `${ORGANIZATION_URL}/${id}` : `${ORGANIZATION_URL}`,
      {
        params: {
          ...filterValues,
          ...paginationValues,
        },
      },
    );
    const data: Organization[] = id
      ? response.data.name
      : response.data.result.map((option: Organization) => ({
          id: option.id,
          email: option.email,
          name: option.name,
          organizationLevel: option.organizationLevel,
          province: option.province,
          county: option.county,
        }));
    return { content: data, totalItems: response.data.totalItems };
  } catch (error) {
    throw error;
  }
}
